// extracted by mini-css-extract-plugin
export default {"headerBackgroundColorHorizontal":"#181818","headerBackgroundColorVertical":"#fff","headerMenuTextColorHorizontal":"#bdbdbd","headerMenuTextColorVertical":"#000"};